/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountOutOfBandPlansQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountOutOfBandPlansQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly outOfBandPlans: ReadonlyArray<GraphQL.AccountPlan> } | null };


export const AccountOutOfBandPlansDocument = gql`
    query AccountOutOfBandPlans($accountId: AccountId!) {
  account(id: $accountId) {
    id
    outOfBandPlans
  }
}
    `;

/**
 * __useAccountOutOfBandPlansQuery__
 *
 * To run a query within a React component, call `useAccountOutOfBandPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountOutOfBandPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountOutOfBandPlansQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountOutOfBandPlansQuery(baseOptions: Apollo.QueryHookOptions<AccountOutOfBandPlansQuery, AccountOutOfBandPlansQueryVariables> & ({ variables: AccountOutOfBandPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountOutOfBandPlansQuery, AccountOutOfBandPlansQueryVariables>(AccountOutOfBandPlansDocument, options);
      }
export function useAccountOutOfBandPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountOutOfBandPlansQuery, AccountOutOfBandPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountOutOfBandPlansQuery, AccountOutOfBandPlansQueryVariables>(AccountOutOfBandPlansDocument, options);
        }
export function useAccountOutOfBandPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountOutOfBandPlansQuery, AccountOutOfBandPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountOutOfBandPlansQuery, AccountOutOfBandPlansQueryVariables>(AccountOutOfBandPlansDocument, options);
        }
export type AccountOutOfBandPlansQueryHookResult = ReturnType<typeof useAccountOutOfBandPlansQuery>;
export type AccountOutOfBandPlansLazyQueryHookResult = ReturnType<typeof useAccountOutOfBandPlansLazyQuery>;
export type AccountOutOfBandPlansSuspenseQueryHookResult = ReturnType<typeof useAccountOutOfBandPlansSuspenseQuery>;
export type AccountOutOfBandPlansQueryResult = Apollo.QueryResult<AccountOutOfBandPlansQuery, AccountOutOfBandPlansQueryVariables>;